import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.is-array";
import _defineProperty from "/Users/jquense/src/react-formal/www/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/jquense/src/react-formal/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import TypescriptTypeValue from './TypescriptTypeValue';
import { cleanDocletValue, getDisplayTypeName, getDoclet } from './utils';

function mapToTypes(propType, tags) {
  var map = function map(pt) {
    return mapToTypes(pt, tags);
  };

  var name = getDisplayTypeName(propType.name);
  var docletType = getDoclet(tags, 'type');

  switch (propType.name) {
    case 'object':
      return {
        name: 'Object'
      };

    case 'shape':
      return {
        name: 'signature',
        type: 'object',
        raw: '',
        signature: {
          properties: Object.entries(propType.value).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            return {
              key: key,
              value: _objectSpread(_objectSpread({}, map(value)), {}, {
                required: value.required
              })
            };
          })
        }
      };

    case 'union':
      return {
        name: 'union',
        elements: propType.value.map(function (n) {
          return typeof n === 'string' ? {
            name: n
          } : n;
        }).map(map)
      };

    case 'enum':
      {
        var enumValues = propType.value || [];

        if (!Array.isArray(enumValues)) {
          return {
            name: enumValues
          };
        }

        return {
          name: 'union',
          elements: enumValues.map(function (e) {
            return {
              name: e.value
            };
          })
        };
      }

    case 'arrayOf':
      return {
        name: 'Array',
        elements: [map(propType.value)]
      };

    case 'custom':
      return {
        name: cleanDocletValue(docletType || propType.raw)
      };

    default:
      return {
        name: 'literal',
        value: name
      };
  }
}

function PropTypeValue(_ref3) {
  var type = _ref3.type,
      tags = _ref3.tags,
      tokens = _ref3.tokens;
  var tsType = useMemo(function () {
    return mapToTypes(type, tags);
  }, [type, tags]);
  return /*#__PURE__*/React.createElement(TypescriptTypeValue, {
    type: tsType,
    tags: tags,
    tokens: tokens
  });
}

export default PropTypeValue;